import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const ListPackageDomainSlice = createSlice({
    name: "ListPackageDomainSlice",
    initialState: {} as IReduxState<string[]>,
    reducers: {
        listPackageDomain: (state) => {
            state.isLoading = true;
        },
        successlistPackageDomain: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        failurelistPackageDomain: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
    },
});

export const {
    listPackageDomain,
    successlistPackageDomain,
    failurelistPackageDomain,
} = ListPackageDomainSlice.actions;

export default ListPackageDomainSlice.reducer;
